import { useNavigate } from "react-router-dom";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Button, IconButton, Chip, Tooltip as MuiTooltip } from "@mui/material";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import HistoryIcon from "@mui/icons-material/History";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import AddIcon from "@mui/icons-material/Add";
import CreatePersona from "../../Modals/createpersona";
import { useState } from "react";

const PersonaDashboard = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  return (
    <>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Persona Dashboard</h1>
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => setOpenModal(true)}
          >
            <AddIcon />
            Create Persona
          </Button>
        </div>
      </div>
      {/* ===== Quick Actions ===== */}

      {/* ======= Stats Overview ======= */}
      <div className="stats_boxes gap_m">
        {/* Total Personas */}
        <a className="cards">
          <div className="data_top">
            <h2>
              6<p>Total Personas</p>
            </h2>

            <figure className="blue">
              <PeopleOutlineIcon fontSize="large" />
            </figure>
          </div>
          <div className="rating_box">
            <p className="green">5 custom created</p>
          </div>
        </a>

        {/* Active Users */}
        <a className="cards">
          <div className="data_top">
            <h2>
              0<p>Active Users</p>
            </h2>

            <figure className="sucess">
              <CheckCircleOutlineIcon fontSize="large" />
            </figure>
          </div>
          <div className="rating_box">
            <p className="green">Using persona dashboards</p>
          </div>
        </a>

        {/* Available Widgets */}
        <a className="cards">
          <div className="data_top">
            <h2>
              8<p>Available Widgets</p>
            </h2>

            <figure className="blue">
              <DashboardCustomizeOutlinedIcon fontSize="large" />
            </figure>
          </div>
      
        </a>

        {/* Last Updated */}
        <a className="cards">
          <div className="data_top">
            <h2>
              Today
              <p>Last Updated</p>
            </h2>

            <figure className="sucess">
              <AccessTimeOutlinedIcon fontSize="large" />
            </figure>
          </div>
          <div className="rating_box">
            <p className="green">Auto-sync enabled</p>
          </div>
        </a>
      </div>

      <div className="mt_20 personas_section">
        {/* LEFT: Available Personas */}
        <div className="personas_left">
          <div className="section_header">
            <h3>Available Personas</h3>
            <span className="count">6 personas</span>
          </div>

          <div className="persona_grid">
            {/* Persona Card */}
            {[
              {
                name: "Super Admin",
                role: "Full Platform Access",
                desc: "Complete visibility across all modules with administrative controls",
                users: 12,
                widgets: 7,
                tag: "Default",
                risk: "High",
                sensitivity: "Critical",
                modified: "Admin (2h ago)",
                active: true,
              },
              {
                name: "Operations Manager",
                role: "Order & Fulfillment Focus",
                desc: "Order processing, inventory management, and logistics oversight",
                users: 8,
                widgets: 4,
                risk: "Medium",
                sensitivity: "Standard",
                modified: "Ops (Yesterday)",
                active: true,
              },
              {
                name: "Finance Team",
                role: "Revenue & Payments",
                desc: "Financial metrics, payment processing, and commission tracking",
                users: 0,
                widgets: 3,
                risk: "High",
                sensitivity: "High",
                modified: "Finance (3d ago)",
                active: false,
              },
              {
                name: "Support Agent",
                role: "Customer Service",
                desc: "Ticket management, customer communications, and issue resolution",
                users: 24,
                widgets: 4,
                risk: "Low",
                sensitivity: "Basic",
                modified: "System (1w ago)",
                active: true,
              },
              {
                name: "Data Analyst",
                role: "Analytics & Insights",
                desc: "Advanced analytics, reporting, and business intelligence",
                users: 4,
                widgets: 4,
                risk: "Medium",
                sensitivity: "Standard",
                modified: "Analyst (2w ago)",
                active: true,
              },
              {
                name: "Vendor Manager",
                role: "Vendor Relations",
                desc: "Vendor onboarding, performance monitoring, relationship management",
                users: 6,
                widgets: 4,
                risk: "Medium",
                sensitivity: "Standard",
                modified: "Ops (1m ago)",
                active: true,
              },
            ].map((p, i) => (
              <div
                className={`persona_card ${p.users === 0 ? "inactive_persona" : ""}`}
                key={i}
              >
                <div className="card_top">
                  <div className="icon_circle">
                    {p.tag === "Default" ? (
                      <LockOutlinedIcon fontSize="small" />
                    ) : (
                      p.name.charAt(0)
                    )}
                  </div>
                  <div className="badges_flex">
                    {p.tag && <span className="badge default">{p.tag}</span>}
                    <span className={`risk_badge ${p.risk.toLowerCase()}`}>
                      {p.risk === "High"
                        ? "🔴"
                        : p.risk === "Medium"
                          ? "🟠"
                          : "🟢"}{" "}
                      {p.risk} Risk
                    </span>
                  </div>
                </div>

                <h4>{p.name}</h4>
                <span className="role">{p.role}</span>
                <p className="desc">{p.desc}</p>

                <div className="meta">
                  <MuiTooltip
                    title={
                      p.users === 0
                        ? "Potential UX issue: No users assigned"
                        : ""
                    }
                  >
                    <span className={p.users === 0 ? "warning_text" : ""}>
                      <PeopleOutlineIcon fontSize="inherit" /> {p.users} users
                    </span>
                  </MuiTooltip>
                  <span>
                    <DashboardCustomizeOutlinedIcon fontSize="inherit" />{" "}
                    {p.widgets} widgets
                  </span>
                </div>

                <div className="audit_trail">
                  <HistoryIcon fontSize="inherit" /> Mod: {p.modified}
                </div>

                <div className="card_footer">
                  
                  <div className="actions">
                    <IconButton
                      size="small"
                      className="icon edit"
                      onClick={() => setOpenModal(true)}
                    >
                      <EditOutlinedIcon fontSize="small" />
                    </IconButton>

                    <IconButton
                      size="small"
                      className="icon duplicate"
                      title="Duplicate Persona"
                    >
                      <ContentCopyIcon fontSize="small" />
                    </IconButton>

                    <IconButton
                      size="small"
                      className="icon view"
                      onClick={() => navigate("view")}
                    >
                      <VisibilityOutlinedIcon fontSize="small" />
                    </IconButton>

                    {p.tag !== "Default" && (
                      <IconButton size="small" className="icon delete">
                        <DeleteOutlineOutlinedIcon fontSize="small" />
                      </IconButton>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT: Widgets + Usage */}
        <div className="personas_right">
          {/* Templates */}
       

          {/* Widget Library */}
          <div className="side_card">
            <div className="d_flex justify-between align-center mb_10">
              <h4>Widget Library</h4>
            
            </div>
            <p className="sub">Widgets to customize persona dashboards</p>

            <div className="widget_categories">
              <div className="cat_section">
                <span className="cat_label">Ops & Logistics</span>
                <ul className="widget_list">
                  <li>
                    <span>Order Pipeline</span>{" "}
                    <Chip label="S" size="small" className="sense_tag" />
                  </li>
                  <li>
                    <span>System Health</span>{" "}
                    <Chip label="S" size="small" className="sense_tag" />
                  </li>
                </ul>
              </div>
              <div className="cat_section">
                <span className="cat_label">Finance</span>
                <ul className="widget_list">
                  <li>
                    <span className="ai_rec">Revenue Overview</span>{" "}
                    <Chip label="SS" size="small" className="sense_tag high" />
                  </li>
                  <li>
                    <span>Payout Tracker</span>{" "}
                    <Chip label="SS" size="small" className="sense_tag high" />
                  </li>
                </ul>
              </div>
              <div className="cat_section">
                <span className="cat_label">AI & Insights</span>
                <ul className="widget_list">
                  <li>
                    <span className="ai_rec">AI Usage Stats</span>{" "}
                    <Chip label="L" size="small" className="sense_tag low" />
                  </li>
                  <li>
                    <span>Active Alerts</span>{" "}
                    <Chip label="M" size="small" className="sense_tag medium" />
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* AI Persona Recommendations */}
          <div className="side_card mt_15 recommendation_card">
            <div className="d_flex align-center gap_10 mb_10">
              <AutoFixHighIcon color="secondary" />
              <h4 className="m_0">AI Recommendations</h4>
            </div>
            <ul className="rec_list">
              <li>
                <InfoOutlinedIcon fontSize="inherit" />
                <span>
                  Ops Manager missing <strong>'Delayed Orders'</strong> widget
                </span>
              </li>
              <li>
                <InfoOutlinedIcon fontSize="inherit" />
                <span>
                  Finance persona could benefit from{" "}
                  <strong>'Refund Trends'</strong>
                </span>
              </li>
              <li className="warning">
                <InfoOutlinedIcon fontSize="inherit" />
                <span>
                  Support Agent overloaded — suggest{" "}
                  <strong>queue split</strong>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <CreatePersona
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default PersonaDashboard;
